import React from "react";
import { HeartHandshake, Users, Activity, House, Wrench, Smile } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const services = [{
  title: "Compliance",
  description: "A1, RUT and tax registration\xA0\xA0\nAudit-ready documentation\xA0\xA0\nGDPR compliant data handling",
  icon: Users,
  image: "https://robust-hedgehog.10web.cloud/wp-content/uploads/2026/03/IMG-20220207-WA0029.jpg?v=b3phzlusug7"
}, {
  title: "Manpower Logistics",
  description: "Rotation planning (flights & transport)\xA0\xA0\nAccommodation coordination\xA0\xA0\nDaily workforce logistics",
  icon: Wrench,
  image: "https://robust-hedgehog.10web.cloud/wp-content/uploads/2026/03/20240806_143144-EFFECTS-scaled.jpg?v=9jl1z6qw7ec"
}, {
  title: "Site Operations",
  description: "On-site supervision\xA0\xA0\nDaily workforce coordination\xA0\xA0\nOperational support on active sites",
  icon: Activity,
  image: "https://robust-hedgehog.10web.cloud/wp-content/uploads/2026/03/IMG-20220207-WA0042.jpg?v=zr5q8d3i1j"
}, {
  title: "Manpower",
  description: "Skilled workforce sourcing\xA0\xA0\nFast onboarding and deployment\xA0\xA0\nInternational teams across Europe",
  icon: HeartHandshake,
  image: "https://robust-hedgehog.10web.cloud/wp-content/uploads/2026/03/Con20-scaled.jpg?v=xl66kmm2z79"
}, {
  title: "Accommodation Services",
  description: "Turnkey housing solutions\xA0\xA0\nFacility management\xA0\xA0\nComfortable setups for rotating teams",
  icon: House,
  image: "https://robust-hedgehog.10web.cloud/wp-content/uploads/2026/03/20191203_153117-scaled.jpg?v=4m5kavq0xnq"
}, {
  title: "Work permits & Immigration",
  description: "Work permits and immigration handling\xA0\xA0\nAuthority coordination\xA0\xA0\nFull legal compliance.",
  icon: Smile,
  image: "https://robust-hedgehog.10web.cloud/wp-content/uploads/2026/03/Con17-scaled.jpg?v=vfp6436v6ym"
}];
export default function OurCareSolutions() {
  return <section data-section-id="24725" id="core-solutions" className="py-16 md:py-20 lg:py-24 bg-primary">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <div className="w-12 h-1 bg-accent mx-auto mb-6 rounded-full" />
          <span className="block font-bold tracking-widest text-accent uppercase mb-3 !font-sans !border-1 border-[oklch(0.9670.001286.375)] !border-none !text-base">PROFESSIONAL SERVICES PROVEN EXPERIENCE FROM INTERNATIONAL DATA CENTER AND PHARMACEUTICAL PROJECTS, INCLUDING WORK ON SITES FOR GLOBAL HYPERSCALE CLIENTS.</span>
          <h2 className="text-3xl font-bold mb-6 !font-sans !text-[hsl(0,0%,100%)] md:text-4xl lg:text-5xl">VANTAGE SUPPORT GROUP&nbsp; &nbsp; <br />Core Services</h2>
          <p className="text-lg text-primary-foreground/80 font-sans leading-relaxed">Vantage Support Group supports complex projects with compliance management, workforce management and logistical execution across Denmark and Scandinavia.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => <div key={index} data-index={index} className="h-full">
              <Card className="h-full border-none shadow-xl hover:shadow-xl hover:border-l-2 hover:border-accent transition-all duration-300 bg-card rounded-[4px] overflow-hidden flex flex-col group">
                <div className="relative h-[200px] w-full overflow-hidden">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>

                <CardContent className="pt-10 pb-8 px-8 flex flex-col flex-grow">
                  <h3 className="text-[28px] font-bold text-foreground mb-3 leading-tight !font-sans">
                    {service.title}
                  </h3>
                  <p className="text-[18px] text-foreground/80 font-sans leading-relaxed mb-6 flex-grow">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}